import { render } from "./OpenProjectsComponent.vue?vue&type=template&id=2d3fa886&scoped=true"
import script from "./OpenProjectsComponent.vue?vue&type=script&lang=js"
export * from "./OpenProjectsComponent.vue?vue&type=script&lang=js"

import "./OpenProjectsComponent.vue?vue&type=style&index=0&id=2d3fa886&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3fa886"]])

export default __exports__